import ABCyaPhaser from "@abcya/abcya_phaser";
import JDialog from "../alphabetbubble/JDialog";
import PopBubble from "../alphabetbubble/PopBubble";
import TimeDial from "../alphabetbubble/TimeDial";
import gameData from "../gameData";
import SoundAssetKeys from "../SoundAssetKeys";
import UIAssetKeys from "../UIAssetKeys";
import Game from "./Game";
import Intro from "./Intro";
import LocalizationSoundAssetKeys from "../Localization-SoundAssetKeys";

export default class PopBubbleScreen extends Phaser.Scene {
    static get KEY() { return 'PopBubbleScreen'; }

    constructor() {
        super({ key: (PopBubbleScreen).KEY });
    }

    init() {
        this.boxes = [];
        this.bodies = [];
        this.world = null;
        this.currentNumberQueue = [];
        this.bubbles = [];
        this.currentNumberToPop = 0;
        this.bubblesPopped = 0;

        this.box2d = (function (scene) {
            // important box2d scale and speed vars
            let SCALE = 30, STEP = 20, TIMESTEP = 1 / STEP;
            let world;
            let lastTimestamp = Date.now();
            let fixedTimestepAccumulator = 0;
            let bodiesToRemove = [];
            let actors = [];
            let bodies = [];

            // box2d world setup and boundaries
            let setup = function () {
                world = new Box2D.Dynamics.b2World(new Box2D.Common.Math.b2Vec2(0, 0.0), true);

                // boundaries - top
                let topFixture = new Box2D.Dynamics.b2FixtureDef;
                topFixture.density = 1;
                topFixture.restitution = 0.1;
                topFixture.shape = new Box2D.Collision.Shapes.b2PolygonShape;
                topFixture.shape.SetAsBox((scene.scale.width) / SCALE, 10 / SCALE);
                let topBodyDef = new Box2D.Dynamics.b2BodyDef;
                topBodyDef.type = Box2D.Dynamics.b2Body.b2_staticBody;
                topBodyDef.position.x = 0 / SCALE;
                topBodyDef.position.y = -60 / SCALE;
                let top = world.CreateBody(topBodyDef);
                top.CreateFixture(topFixture);

                // boundaries - floor
                let floorFixture = new Box2D.Dynamics.b2FixtureDef;
                floorFixture.density = 1;
                floorFixture.restitution = 0.1;
                floorFixture.shape = new Box2D.Collision.Shapes.b2PolygonShape;
                floorFixture.shape.SetAsBox((scene.scale.width) / SCALE, 10 / SCALE);
                let floorBodyDef = new Box2D.Dynamics.b2BodyDef;
                floorBodyDef.type = Box2D.Dynamics.b2Body.b2_staticBody;
                floorBodyDef.position.x = -25 / SCALE;
                floorBodyDef.position.y = (scene.scale.height - 40) / SCALE;
                let floor = world.CreateBody(floorBodyDef);
                floor.CreateFixture(floorFixture);

                // boundaries - left
                let leftFixture = new Box2D.Dynamics.b2FixtureDef;
                leftFixture.shape = new Box2D.Collision.Shapes.b2PolygonShape;
                //leftFixture.shape.SetAsBox(20 / SCALE, (550 + 500) / SCALE);
                leftFixture.shape.SetAsBox(20 / SCALE, (scene.scale.width) / SCALE);
                let leftBodyDef = new Box2D.Dynamics.b2BodyDef;
                leftBodyDef.type = Box2D.Dynamics.b2Body.b2_staticBody;
                leftBodyDef.position.x = -70 / SCALE;
                leftBodyDef.position.y = -25 / SCALE;
                let left = world.CreateBody(leftBodyDef);
                left.CreateFixture(leftFixture);

                // boundaries - right
                let rightFixture = new Box2D.Dynamics.b2FixtureDef;
                rightFixture.shape = new Box2D.Collision.Shapes.b2PolygonShape;
                rightFixture.shape.SetAsBox(20 / SCALE, (scene.scale.height) / SCALE);
                let rightBodyDef = new Box2D.Dynamics.b2BodyDef;
                rightBodyDef.type = Box2D.Dynamics.b2Body.b2_staticBody;
                rightBodyDef.position.x = (scene.scale.width - 30) / SCALE;
                rightBodyDef.position.y = -25 / SCALE;
                let right = world.CreateBody(rightBodyDef);
                right.CreateFixture(rightFixture);
            }

            // actor object - this is responsible for taking the body's position and translating it to your easel display object
            let actorObject = function (body, skin) {
                this.body = body;
                this.skin = skin;
                this.update = function () {  // translate box2d positions to pixels
                    this.skin.x = this.body.GetWorldCenter().x * SCALE;
                    this.skin.y = this.body.GetWorldCenter().y * SCALE;
                }
                actors.push(this);
            }

            // create bird body shape and assign actor object
            let createCoin = function (skin) {
                let fixture = new Box2D.Dynamics.b2FixtureDef;
                fixture.density = 1;
                fixture.restitution = 0.6;
                fixture.shape = new Box2D.Collision.Shapes.b2CircleShape(24 / SCALE);
                let bodyDef = new Box2D.Dynamics.b2BodyDef;
                bodyDef.type = Box2D.Dynamics.b2Body.b2_dynamicBody;
                bodyDef.position.x = skin.x / SCALE;
                bodyDef.position.y = skin.y / SCALE;
                let coin = world.CreateBody(bodyDef);
                coin.CreateFixture(fixture);

                // assign actor
                let actor = new actorObject(coin, skin);
                coin.SetUserData(actor);  // set the actor as user data of the body so we can use it later: body.GetUserData()
                bodies.push(coin);
            }

            // remove actor and it's skin object
            let removeActor = function (actor) {
                if (actor.skin != null) {
                    if (actor.skin.scene != null) {
                        actor.skin.destroy();
                    }
                }
                actors.splice(actors.indexOf(actor), 1);
            }

            // fixture and bodyDef defined in skin object
            let createBody = function (skin) {
                skin.bodyDef.position.x = skin.x / SCALE;
                skin.bodyDef.position.y = skin.y / SCALE;

                let body = world.CreateBody(skin.bodyDef);
                body.destroy = () => { }// Phaser requires bodies to have a destroy function, so create an empty one
                body.CreateFixture(skin.fixture);

                // assign actor
                let actor = new actorObject(body, skin);
                body.SetUserData(actor);  // set the actor as user data of the body so we can use it later: body.GetUserData()
                bodies.push(body);

                skin.body = body;

                return body;
            };

            // box2d update function. delta time is used to avoid differences in simulation if frame rate drops
            let update = function () {
                let now = Date.now();
                let dt = now - lastTimestamp;
                fixedTimestepAccumulator += dt;
                lastTimestamp = now;
                while (fixedTimestepAccumulator >= STEP) {
                    // remove bodies before world timestep
                    for (let i = 0, l = bodiesToRemove.length; i < l; i++) {
                        removeActor(bodiesToRemove[i].GetUserData());
                        bodiesToRemove[i].SetUserData(null);
                        world.DestroyBody(bodiesToRemove[i]);
                    }
                    bodiesToRemove = [];

                    // update active actors
                    for (let i = 0, l = actors.length; i < l; i++) {
                        actors[i].update();
                    }

                    world.Step(TIMESTEP, 10, 10);

                    fixedTimestepAccumulator -= STEP;
                    world.ClearForces();
                }
            }

            // create coin body shape and assign actor object
            let createBubble = function (skin) {
                let fixture = new Box2D.Dynamics.b2FixtureDef;
                fixture.density = 1;
                fixture.restitution = 0.6;
                fixture.shape = new Box2D.Collision.Shapes.b2CircleShape(24 / SCALE);
                let bodyDef = new Box2D.Dynamics.b2BodyDef;
                bodyDef.type = Box2D.Dynamics.b2Body.b2_dynamicBody;

                bodyDef.position.x = skin.x / SCALE;
                bodyDef.position.y = skin.y / SCALE;
                let coin = world.CreateBody(bodyDef);
                coin.CreateFixture(fixture);

                // assign actor
                let actor = new actorObject(coin, skin);
                coin.SetUserData(actor);  // set the actor as user data of the body so we can use it later: body.GetUserData()
                bodies.push(coin);
            };

            let pauseResume = function (p) {
                if (p) {
                    TIMESTEP = 0;
                } else { TIMESTEP = 1 / STEP; }
                lastTimestamp = Date.now();
            }

            return {
                setup: setup,
                update: update,
                createCoin: createCoin,
                createBody: createBody,
                createBubble: createBubble,
                pauseResume: pauseResume
            }
        })(this);
    }

    create() {

        let width = this.scale.width;

        ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._intro_background, this).setOrigin(0);

        this.addFish();

        this.timeDial = new TimeDial(this);
        this.timeDial.x = width / 2;
        this.timeDial.y = 50;
        this.add.existing(this.timeDial);

        this.box2d.setup(this);

        this.showBonusRoundDialog();
    }

    addFish() {
        this.doFishMotion("fish1", -200, 300, 27400);
        this.doFishMotion("fish2", 1500, 100, 29400);
        this.doFishMotion("fish3", 1500, 200, 25400);
        this.doFishMotion("fish4", 1500, 400, 31400);
    }

    doFishMotion(spriteName, startX, startY, time) {
        let sprite = ABCyaPhaser.Images.addImage(startX, startY, spriteName, this, "piecesData2");

        let endX = -200;
        if (startX < 0) {
            endX = 1500;
        }

        ABCyaPhaser.Tweens.addTween(sprite, time, { x: endX, repeat: -1 }, Phaser.Math.Easing.Linear);
        ABCyaPhaser.Tweens.addTween(sprite, 600, { scaleX: 1.1, scaleY: 0.9, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Linear);
    }

    showBonusRoundDialog() {
        this.inSound = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
        this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this.inSound.destroy());
        ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._pop_in_alphabetical, this.inSound);

        this.bonusDialog = new JDialog(this, null, UIAssetKeys._go_button, null, null, 1);
        this.bonusDialog.x = this.scale.width / 2;
        this.bonusDialog.y = this.scale.height / 2;

        this.bonusDialog.doAction1 = this.closeBonusDialog.bind(this);
        this.bonusDialog.button1.y += 135;

        this.add.existing(this.bonusDialog);
    }

    closeBonusDialog() {
        this.inSound.stop();
        this.bonusDialog.destroy();

        this.makeBubbleNumbers();

        //start timer
        this.timeDial.start();
    }

    makeBubbleNumbers() {
        let level = gameData.CURRENT_LEVEL;

        this.limit = 6;

        this.startOffset = 0;
        if (level == 1) {
            this.limit = 6;
            this.startOffset = 0;
        } else if (level == 2) {
            this.limit = 6;
            this.startOffset = 6;
        } else if (level == 3) {
            this.limit = 7;
            this.startOffset = 12;
        } else if (level == 4) {
            this.limit = 7;
            this.startOffset = 19;
        }

        this.currentNumberToPop = this.startOffset;

        for (let i = 0; i < this.limit; i++) {

            let num = i + this.startOffset;

            let bubble = new PopBubble(this, num);
            bubble.x = Phaser.Math.Between(150, 800);
            bubble.y = Phaser.Math.Between(100, 500);
            bubble.clickAction = this.bubbleClicked.bind(this);

            this.box2d.createBody(bubble);

            this.add.existing(bubble);
            this.bubbles.push(bubble);
        }

        this.applyRandomForcesToBubbles();

        ABCyaPhaser.Timer.addRepeatingEvent(this, 2000, this.applyRandomForcesToBubbles.bind(this), -1);
    }

    applyRandomForcesToBubbles () {
        for(let i = 0; i < this.bubbles.length; i++) {

            let bubble = this.bubbles[i];
            if(bubble) {

                //apply random forces for floating type look
                let xForce = Phaser.Math.Between(0, 100) - 50;
                let yForce = Phaser.Math.Between(0, 100) - 50;

                // shoot the ball
                bubble.body.ApplyImpulse(new Box2D.Common.Math.b2Vec2(xForce/SCALE, yForce/SCALE),
                    bubble.body.GetWorldCenter());
            }
        }
    }

    bubbleClicked(bubble) {
        if (bubble.number == this.currentNumberToPop) {
            this.bubblesPopped++;
            bubble.pop(this.bubblesPopped);
            this.currentNumberToPop++;

            if (this.currentNumberToPop == this.startOffset + this.limit) {

                this.gameOver();
            }
        } else {

            // wrong number clicked
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._number_bounce, this);

            let xForce = Phaser.Math.Between(0, 4000) - 2000;
            let yForce = Phaser.Math.Between(0, 4000) - 2000;

            // shoot the ball
            bubble.body.ApplyImpulse(new Box2D.Common.Math.b2Vec2(xForce / SCALE, yForce / SCALE),
                bubble.body.GetWorldCenter());
        }
    }

    gameOver() {
        this.timeDial.stop();
        let seconds = this.timeDial.getTime();

        gameData.CURRENT_LEVEL++;
        this.showTimeTakenDialog(seconds);

        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._bonus_round_complete, this);
    }

    showTimeTakenDialog(time) {
        if (time < gameData.BEST_BONUS_TIME) {
            gameData.BEST_BONUS_TIME = time;
        }

        if (gameData.CURRENT_LEVEL > 4) {
            this.timeDialog = new JDialog(this, null, UIAssetKeys._go_button, null, null, 2, time);
            this.timeDialog.button1.y += 135;

        } else {
            this.timeDialog = new JDialog(this, null, UIAssetKeys._next_round_button, null, null, 2, time);
            this.timeDialog.button1.y += 155;
        }

        this.timeDialog.x = this.scale.width / 2;
        this.timeDialog.y = this.scale.height / 2;
        this.timeDialog.doAction1 = this.closeTimeDialog.bind(this);

        this.add.existing(this.timeDialog);

        this.timeDialog.playSound();
    }

    closeTimeDialog() {
        this.timeDialog.destroy();

        if (gameData.CURRENT_LEVEL > 4) {
            gameData.CURRENT_LEVEL = 1;
            this.showBestDialog();
        } else {
            this.cleanUp();
        }
    }

    showBestDialog() {
        this.bestDialog = new JDialog(this, null, UIAssetKeys._play_again_button, null, null, 4, gameData.BEST_BONUS_TIME);
        this.bestDialog.playSound();
        this.bestDialog.x = this.scale.width / 2;
        this.bestDialog.y = this.scale.height / 2;

        this.bestDialog.doAction1 = this.closeBestDialog.bind(this);
        this.bestDialog.button1.y += 155;

        this.add.existing(this.bestDialog);
    }

    closeBestDialog() {
        this.bestDialog.destroy();
        this.brandNewGame();
    }

    brandNewGame() {
        this.scene.start(Intro.KEY);
    }

    cleanUp (){
        this.scene.start(Game.KEY);
    }

    update() {
        this.box2d.update();
    }
}

const SCALE = 30;
const STEP = 20;
const TIMESTEP = 1 / STEP;
